import { getHeaders, makeRequest } from '@orientaction/utils';
import config from './config';

const qs = require('qs');

const url = config.api_url;

export const getTestAnalytics = async (token: string, testId: string) => {
  const fullUrl = `${url}/api/tests/${testId}/analytics`;
  return makeRequest(fullUrl, 'GET', {}, getHeaders(token));
};

export const getTestReviews = async (token: string, testId: string, page = 0, limit = 12) => {
  const searchParams = qs.stringify({
    page,
    limit,
  });
  const fullUrl = `${url}/api/tests/${testId}/reviews?${searchParams}`;
  return makeRequest(fullUrl, 'GET', {}, getHeaders(token));
};

export const createTestReview = async (token: string, reviewData: any) => {
  return makeRequest(
    `${url}/api/test-reviews/create`,
    'POST',
    { data: reviewData },
    getHeaders(token)
  );
};

export const checkUserHasReviewed = async (token: string, testId: string) => {
  const fullUrl = `${url}/api/test-reviews/user-has-reviewed/${testId}`;
  return makeRequest(fullUrl, 'GET', {}, getHeaders(token));
};
